/** Drop SW-managed caches + the service worker, then reload so fresh assets are fetched. */
export const clearCacheAndReload = async (): Promise<void> => {
  try {
    // Clear SW-managed caches (precache + runtime cache)
    if (window.caches) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((cache) => caches.delete(cache)));
    }

    // Force the service worker to re-fetch everything on next load
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        await registration.unregister();
      }
    }
  } catch (err) {
    console.error('Cache clearing failed:', err);
  }

  // Reload the page to fetch fresh assets and re-register the SW
  window.location.reload();
};
